/**
 * IndexedDB persistence for unfinished voice recordings.
 * Tiny wrapper — single object store "recordings" keyed by id.
 */

const DB_NAME = "kinly-voice";
const STORE = "recordings";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    let out;
    Promise.resolve(fn(store)).then((v) => { out = v; });
    t.oncomplete = () => resolve(out);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  });
}

export async function saveRecording({ id, blob, mime, durationMs, familyId, transcript = "" }) {
  return tx("readwrite", (store) =>
    store.put({
      id, blob, mime, durationMs, familyId, transcript,
      saved_at: new Date().toISOString(),
    })
  );
}

export async function getRecording(id) {
  return tx("readonly", (store) =>
    new Promise((resolve, reject) => {
      const req = store.get(id);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    })
  );
}

export async function listRecordings(familyId) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, "readonly");
    const store = t.objectStore(STORE);
    const all = [];
    store.openCursor().onsuccess = (e) => {
      const cur = e.target.result;
      if (cur) {
        if (!familyId || cur.value.familyId === familyId) all.push(cur.value);
        cur.continue();
      } else {
        resolve(all);
      }
    };
    t.onerror = () => reject(t.error);
  });
}

export async function deleteRecording(id) {
  return tx("readwrite", (store) => store.delete(id));
}
